import { Component, OnInit } from '@angular/core';
import { Authorization, UserDto } from '../models/data.model';
import { CommonService } from '../services/common.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthGuardService } from '../services/authGuard';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from '../services/data.service';
import { LocalSettingsService } from '../services/local-settings.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-openIdLogin',
  templateUrl: './openIdLogin.component.html',
  styleUrls: ['./openIdLogin.component.css']
})

export class OpenIdLoginComponent implements OnInit {
  LoginFallito: boolean  = false; 

  constructor(private service: CommonService<Authorization>,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthGuardService,
    private formBuilder: FormBuilder,
    public translate: TranslateService,
    private storageService: LocalSettingsService,
    private toastr: ToastrService) { }


    
  ngOnInit() {
    let _token;
    this.route.queryParams.subscribe(result => {
      _token = result['token'];

      console.log(_token);
      if (_token == '' || _token == undefined) {
        this.service.openIdLogin();
      }
      else {
        //token non va inserito nell url bisogna collegare direttamente il valore
        this.service.getOpenIDToken('api/auth/AngularOpenIdLogin?token=' + encodeURIComponent(_token)).subscribe(result => {
          console.log("result", result);
          if (result != null) {
            if (result != null) {
              console.log('this is login result : ', result);
              this.authService.setLoggedIn(true);
              this.authService.setProfile(result);


              this.service.setPrincipal(result as Authorization);
              //remember login ?! da testare
              let loginInfo = new UserDto();
              loginInfo.username = this.authService.getProfile().Username;
              this.storageService.setCredential(loginInfo);
            }
            this.router.navigate(['/']);
          }
        }, error => {
          console.error(error);
          this.LoginFallito = true;
          //23-10-2024: il messaggio di errore gestito dal ritorno del back end 
          this.translate.get(["LOGIN.LOGINFAILTITLE"])
            .subscribe(values => {
              this.toastr.error(error.error, values["LOGIN.LOGINFAILTITLE"]);
            });
        });
      }
    });

  }

  redirectToLogout() {
    var url = environment.openIdUrl + environment.openIdlogoutUrl 
    window.location.href = url
  }
}
